import axios from "axios";
import { getAuthToken, removeAuthToken } from "./token-util";
import { ConfigValue } from "../config";
import { Navigate } from "react-router-dom";
import routes from "src/config/routes";

// TODO: Due to windows timeout was set to 15000
const Axios = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT,
  timeout: 120000, //150000000,
  headers: {
    "Content-Type": "application/json",
  },
});

const Axios_1 = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_1,
  timeout: 120000, //150000000,
  headers: {
    "Content-Type": "application/json",
  },
});

const Axios_2 = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_2,
  timeout: 120000, //150000000,
  headers: {
    "Content-Type": "application/json",
  },
});
const Axios_EmailTemplate = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_EMAIL_TEMPLATE,
  timeout: 120000, //150000000,
  headers: {
    "Content-Type": "application/json",
  },
});

const Axios_AdminService_V2 = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_ADMIN_SERVICE_V2,
  timeout: 120000, //150000000,
  headers: {
    "Content-Type": "application/json",
  },
});

const Axios_PermissionsModule = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_PERMISSIONS_MODULE,
  timeout: 120000,
  headers: {
    "Content-Type": "application/json",
  },
});
// Change request data/error here
Axios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

Axios_1.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    config.headers.Authorization = `Bearer ${token ? token : ""}`;

    // ✅ Detect FormData uploads and remove JSON header
    if (config.data instanceof FormData) {
      // Let browser set proper multipart/form-data boundary
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error),
);

Axios_1.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

Axios_2.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Axios_2.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

Axios_EmailTemplate.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const handleFailureResponse = (response: any) => {
  if (
    response?.data &&
    (response.data.status === "failure" ||
      (typeof response.data.code === "number" && response.data.code >= 400))
  ) {
    if (response.data.code === 401) {
      removeAuthToken();
      window.location.reload();
      return Promise.reject(new Error("Unauthorized"));
    }

    const errorMsg =
      response.data.message ||
      response.data.error_description ||
      (typeof response.data.error === "string" ? response.data.error : "") ||
      "Request failed";
    const error: any = new Error(errorMsg);
    error.response = response;
    error.data = response.data;
    error.status = response.data.code;
    return Promise.reject(error);
  }
  return response;
};

Axios_EmailTemplate.interceptors.response.use(
  handleFailureResponse,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

Axios_AdminService_V2.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Axios_AdminService_V2.interceptors.response.use(
  handleFailureResponse,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

Axios_PermissionsModule.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Axios_PermissionsModule.interceptors.response.use(
  handleFailureResponse,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);
const ManualTransactionAxios = axios.create({
  baseURL: ConfigValue.PUBLIC_REST_API_ENDPOINT_1,
  timeout: 120000,
  headers: {
    "Content-Type": "application/json",
  },
});

ManualTransactionAxios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers.Authorization = `Bearer ${token ? token : ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ManualTransactionAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      removeAuthToken();
      window.location.reload();
    }

    return Promise.reject(error);
  },
);

export class HttpClient {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data?: unknown, options?: any) {
    const response = await Axios.put<T>(url, data, options);
    return response.data;
  }

  static async patch<T>(url: string, data?: unknown, options?: any) {
    const response = await Axios.patch<T>(url, data, options);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios.delete<T>(url);
    return response.data;
  }
}

export class HttpClient_1 {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios_1.get<T>(url, { params });
    return response.data;
  }

  static async getPdf(
    url: string,
    params?: unknown,
    headers?: Record<string, any>,
  ) {
    const response = await Axios_1.get(url, {
      params,
      headers: {
        ...headers,
      },
      responseType: "blob", // important for PDF
    });

    return response.data; // raw blob
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios_1.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios_1.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios_1.delete<T>(url);
    return response.data;
  }
}

export class HttpClient_2 {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios_2.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios_2.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios_2.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios_2.delete<T>(url);
    return response.data;
  }
}

export class HttpClient_EmailTemplate {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios_EmailTemplate.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios_EmailTemplate.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios_EmailTemplate.put<T>(url, data);
    return response.data;
  }

    static async patch<T>(url: string, data: unknown) {
    const response = await Axios_EmailTemplate.patch<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios_EmailTemplate.delete<T>(url);
    return response.data;
  }
}

export class HttpClient_AdminServiceV2 {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios_AdminService_V2.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios_AdminService_V2.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios_AdminService_V2.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios_AdminService_V2.delete<T>(url);
    return response.data;
  }
}
export class ManualTransactionsHttpClient {
  static async get<T>(
    url: string,
    params?: unknown,
    headers?: Record<string, any>,
  ) {
    const response = await ManualTransactionAxios.get<T>(url, {
      params,
      headers: {
        ...headers, // merge custom headers
      },
    });
    return response.data;
  }
  static async post<T>(
    url: string,
    data: unknown,
    options?: any,
    headers?: Record<string, any>,
  ) {
    const response = await ManualTransactionAxios.post<T>(url, data, {
      ...options,
      headers: {
        ...(options?.headers || {}), // keep headers passed in options
        ...(headers || {}), // merge/override with explicit headers
      },
    });
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await ManualTransactionAxios.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await ManualTransactionAxios.delete<T>(url);
    return response.data;
  }
}

export class HttpClient_PermissionsModule {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios_PermissionsModule.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios_PermissionsModule.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios_PermissionsModule.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios_PermissionsModule.delete<T>(url);
    return response.data;
  }
}
